//ActionTypes
///systemmodule/list
export const GET_SYSTEM_MODULE_LIST = "GET_SYSTEM_MODULE_LIST";
export const GET_SYSTEM_MODULE_LIST_SUCCESS = "GET_SYSTEM_MODULE_LIST_SUCCESS";
export const GET_SYSTEM_MODULE_LIST_FAIL = "GET_SYSTEM_MODULE_LIST_FAIL";
///systemmodule/data
export const GET_SYSTEM_MODULE_DATA = "GET_SYSTEM_MODULE_DATA";
export const GET_SYSTEM_MODULE_DATA_SUCCESS = "GET_SYSTEM_MODULE_DATA_SUCCESS";
export const GET_SYSTEM_MODULE_DATA_FAIL = "GET_SYSTEM_MODULE_DATA_FAIL";
///systemmodule/activate
export const ACTIVATE_SYSTEM_MODULE = "ACTIVATE_SYSTEM_MODULE";
export const ACTIVATE_SYSTEM_MODULE_SUCCESS = "ACTIVATE_SYSTEM_MODULE_SUCCESS";
export const ACTIVATE_SYSTEM_MODULE_FAIL = "ACTIVATE_SYSTEM_MODULE_FAIL";
///systemmodule/deactivate
export const DEACTIVATE_SYSTEM_MODULE = "DEACTIVATE_SYSTEM_MODULE";
export const DEACTIVATE_SYSTEM_MODULE_SUCCESS = "DEACTIVATE_SYSTEM_MODULE_SUCCESS";
export const DEACTIVATE_SYSTEM_MODULE_FAIL = "DEACTIVATE_SYSTEM_MODULE_FAIL";
///systemmodule/create
export const CREATE_SYSTEM_MODULE = "CREATE_SYSTEM_MODULE";
export const CREATE_SYSTEM_MODULE_SUCCESS = "CREATE_SYSTEM_MODULE_SUCCESS";
export const CREATE_SYSTEM_MODULE_FAIL = "CREATE_SYSTEM_MODULE_FAIL";
///systemmodule/update
export const UPDATE_SYSTEM_MODULE = "UPDATE_SYSTEM_MODULE";
export const UPDATE_SYSTEM_MODULE_SUCCESS = "UPDATE_SYSTEM_MODULE_SUCCESS";
export const UPDATE_SYSTEM_MODULE_FAIL = "UPDATE_SYSTEM_MODULE_FAIL";
///systemmodule/delete
export const DELETE_SYSTEM_MODULE = "DELETE_SYSTEM_MODULE";
export const DELETE_SYSTEM_MODULE_SUCCESS = "DELETE_SYSTEM_MODULE_SUCCESS";
export const DELETE_SYSTEM_MODULE_FAIL = "DELETE_SYSTEM_MODULE_FAIL";
